import React from 'react';
import PropTypes from 'prop-types';
import { HotelSelectorDropdownEl } from './HotelSelectorDropdown.style';
import { EntryPoint, LegType } from '../../models';
import { LocationAutocompleteSource } from '../LocationAutocomplete/LocationAutocompleteSource';
import { PopularHotelsDestinationsSourceDesktop } from '../PopularHotelsDestinations/PopularHotelsDestinationsSourceDesktop';

const classNames = 'odf-box odf-box-layer odf-popup odf-popup-flex odf-space-outer-top-xs opened';

const getHotelSelectorSources = () => {
    const locationAutocomplete = LocationAutocompleteSource({
        departureOrArrival: LegType.ARRIVAL,
        activeProduct: EntryPoint.HOTELS,
    });
    const popularHotelsDestinations = PopularHotelsDestinationsSourceDesktop();
    return [locationAutocomplete, popularHotelsDestinations];
};
const sources = getHotelSelectorSources();

const HotelSelectorDropdown = ({
    focus,
    onClickItem,
    displayedWord,
}) => {
    return (
        <>
            {focus && (
                <HotelSelectorDropdownEl className={classNames}>
                    <ul>
                        {sources.map((source) => source.render({
                            displayedWord,
                            onClickItem,
                        }))}
                    </ul>
                </HotelSelectorDropdownEl>
            )}
        </>
    );
};

HotelSelectorDropdown.propTypes = {
    displayedWord: PropTypes.string.isRequired,
    onClickItem: PropTypes.func.isRequired,
    focus: PropTypes.bool,
};

HotelSelectorDropdown.defaultProps = {
    focus: false,
};

export default HotelSelectorDropdown;
